<template lang='pug'>
//- Register-Page
div(:class='$style[`cc-register-container`]')
  div(:class='$style[`cc-register-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 歡
        span.font-normal-theme 迎
        span.no-wrap 您的加入

      span.font-medium(:class='$style[`cc-banner-sub-title`]')
        span 請選擇註冊的會員身份
        //- router-link(
        //-   tag='span'
        //-   role='button'
        //-   tabindex='0'
        //-   aria-label='看說明'
        //-   to='/tutorial#doctor'
        //-   :class='$style[`cc-banner-sub-title-tip`]')
        //-   IconInfo(:size='20' :color='`#b1b1b1`')
        //-   !='看說明'

    div(:class='$style[`cc-banner-type-nav`]')
      button(
        tabindex='0'
        aria-label='註冊為醫護會員'
        :class='[$style[`cc-type-nav`], $style[`cc-type-doctor`], $style[isFormDoctor ? `js-click-active` : ``]]'
        @click='handleMemberTypeClick(`doctor`)') 醫護人員

      button(
        tabindex='0'
        aria-label='註冊為一般會員'
        :class='[$style[`cc-type-nav`], $style[`cc-type-normal`], $style[isFormNormal ? `js-click-active` : ``]]'
        @click='handleMemberTypeClick(`normal`)') 一般會員


  //- transition(name='ani-slide-up-fade')
  RegisterForm(v-if='isFormDoctor || isFormNormal' ref='RegisterFormList' :key='`form-${nextTick}`' :isDoctor='isFormDoctor' :isNormal='isFormNormal')

  div(v-else :class='$style[`cc-register-poster`]')
    figure


</template>

<script>
import RegisterForm from './RegisterForm';
import IconInfo from '../../icon/Info';

export default {
  metaInfo() {
    return {
      title: '加入會員',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/register',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/register',
      }],
    };
  },

  components: {
    RegisterForm,
    IconInfo,
  },

  // created() {
  //   if (!this.loginStatus) {
  //     this.$router.push({ name: 'index'}).catch(() => true);
  //     return;
  //   }
  // },

  data() {
    return {
      // memberType: '',
      nextTick: 1,
      isFormDoctor: false,
      isFormNormal: false,
    };
  },

  methods: {
    handleMemberTypeClick(type) {
      this.isFormDoctor = false;
      this.isFormNormal = false;
      // Reset Data of RegisterForm Component to Default
      // this.$refs.RegisterFormList.handleResetDoctorToDefault(type);

      switch (type) {
        case 'doctor':
          this.isFormDoctor = true;
          break;

        case 'normal':
          this.isFormNormal = true;
          break;

        default:
          break;
      }

      this.nextTick += 1;
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/member/register.scss';
</style>
